
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddEditFeeMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [feeName, setFeeName] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [feeNameErrText, setFeeNameErrText] = useState('');
    const [feeNameErr, setFeeNameErr] = useState(false);

    const submitButtonRef = useRef(null);
    const feeNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        setTimeout(() => {
            feeNameRef.current?.focus();
        }, 100);
    }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setFeeName(props?.masterData?.FeeName);
        }
    }, []);

    const onCancel = () => {
        props.onCancel();
        setFeeName('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(feeName)) {
            formIsValid = false;
            setFeeNameErr(true);
            setFeeNameErrText("Fee Name is required");
        } else {
            setFeeNameErr(false);
            setFeeNameErrText("");
        }
        return formIsValid;
    };

    const AddFeeMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    FeeName: feeName?.trim().replace(/\s+/g, ' '),
                    CreatedBy: securityUserID,
                };
                await api
                    .post(APIConstant.path.AddUpdateFeeMaster, data).then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        setFeeName(value);
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-12 p-pt-2">
                    <div className="custom-inputs">
                        <label className='' htmlFor="feeName">Fee Name<span style={{ color: "red" }}>*</span></label>
                        <FloatLabel>
                            <InputText
                                ref={feeNameRef}
                                className="p-mt-2 p-w-100"
                                id="feeName"
                                type="text"
                                maxLength={20}
                                placeholder="Fee Name"
                                value={feeName}
                                autoFocus={true}
                                onChange={(e) => handleChange(e)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {feeNameErr ? feeNameErrText : null}
                        </span>
                    </div>
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={(e) => onCancel()}> Cancel </Button>
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Save" severity="secondary" raised onClick={(e) => AddFeeMaster()} />
            </div>
        </div>
    );
};

export default AddEditFeeMasterDialog;
